export default "__VITE_ASSET__Blzzo7XJ__"